import { render, staticRenderFns } from "./VTBaseTemplate.vue?vue&type=template&id=542ceb31&scoped=true&"
import script from "./VTBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./VTBaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VTBaseTemplate.vue?vue&type=style&index=0&id=542ceb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ceb31",
  null
  
)

export default component.exports